"use strict";

module.exports = {
    init: function () {
        var $flipdown = $("#flipdown");

        if ($flipdown.length === 0) {
            return;
        }

        var date = $flipdown.data("date").split("/");
        var time = $flipdown.data("time").split(":");
        var timeTexts = {
            days: $flipdown.data("days") || "DAYS",
            hours: $flipdown.data("hours") || "HOURS",
            minutes: $flipdown.data("minutes") || "MINUTES",
            seconds: $flipdown.data("seconds") || "SECONDS"
        };
        var noDays = $flipdown.data("nodays") || false;

        if ($flipdown.length) {
            var countdownToDate = new Date();
            var timeOffset = countdownToDate.getTimezoneOffset();
            var countdownTime = 0;

            countdownToDate.setDate(date[0]);
            countdownToDate.setMonth(Number(date[1]) - 1);
            countdownToDate.setYear(date[2]);
            countdownToDate.setHours(time[0]);
            countdownToDate.setMinutes(time[1]);
            countdownToDate.setSeconds(time[2]);

            countdownTime = countdownToDate.getTime() / 1000 - timeOffset * 60 + 1; // ms to secs and removes the client timezone offset

            new FlipDown(countdownTime, {headings: [timeTexts.days, timeTexts.hours, timeTexts.minutes, timeTexts.seconds], noDays: noDays}).start();
        }
    }
};
